<template>
  <div class="block">
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" @prev-click='previouspage'
      @next-click='nextpage' :current-page="PageData.currentPage" :page-sizes="pageSize" :page-size="PageData.pageSize?PageData.pageSize:10" layout="total, sizes, prev, pager, next, jumper"
      :total="PageData.total">
    </el-pagination>
  </div>
</template>

<script>
  export default {
    props: ['PageData'],
    data() {
      return {
        pageSize: [5, 10, 15, 20]
      }
    },
    created() {
    },
    methods: {
      // 下一頁
      nextpage(val) {
        this.$emit('nextpage', val);
      },
      // 上一頁
      previouspage(val) {
        this.$emit('previouspage', val)
      },
      handleSizeChange(val) {
        this.$emit('handleSizeChange', val)
      },
      handleCurrentChange(val) {
        this.$emit('handleCurrentChange', val)
      },
    }
  }
</script>
